export function DisableStockCheck() {
    return function(dispatch) {
        dispatch({
            type: 'APP/DISABLE_STOCK_CHECK',
        });
    };
}

export function EnableStockCheck() {
    return function(dispatch) {
        dispatch({
            type: 'APP/ENABLE_STOCK_CHECK',
        });
    };
}

export function ClearEvent() {
    return function(dispatch) {
        dispatch({
            type: 'APP/CLEAR_EVENT',
        });
    };
}
